// extracted by mini-css-extract-plugin
module.exports = {"content":"MessagePreview_content__2SXdb","messageContent":"MessagePreview_messageContent__2HNPm","link":"MessagePreview_link__2B1SR"};